<template>
  <div>
    <LibraryList v-if="fieldCode === 'library'" />
    <ComplexMuseumList v-else-if="fieldCode === 'museum'" />
    <ComplexMedicalList v-else-if="fieldCode === 'medical'" />
    <ComplexDaycareList v-else-if="fieldCode === 'daycare'" />
    <ComplexOfficeList v-else-if="fieldCode === 'office'" />
    <ComplexIndoorAuditoriumList v-else-if="fieldCode === 'indoor-auditorium'" />
    <ComplexMixedUseBuildingList v-else-if="fieldCode === 'mixed-use-building'" />
    <ComplexBuildingList v-else-if="fieldCode === 'building'" />
    <FieldFacilityBridgeList v-else-if="fieldCode === 'bridge'" />
    <FieldFacilityRetainingWallList v-else-if="fieldCode === 'retaining-wall'" />
  </div>
</template>

<script>
import FieldFacilityComplexList from "@/views/_BS/FieldFacilityComplexList.vue";
import LibraryList from "@/views/_BS/ComplexLibraryList.vue";
import ComplexMuseumList from "@/views/_BS/ComplexMuseumList.vue";
import ComplexMedicalList from "@/views/_BS/ComplexMedicalList.vue";
import ComplexMixedUseBuildingList from "@/views/_BS/ComplexMixedUseBuildingList.vue";
import ComplexIndoorAuditoriumList from "@/views/_BS/ComplexIndoorAuditoriumList.vue";
import ComplexOfficeList from "@/views/_BS/ComplexOfficeList.vue";
import ComplexBuildingList from "@/views/_BS/ComplexBuildingList.vue";
import ComplexDaycareList from "@/views/_BS/ComplexDaycareList.vue";
import FieldFacilityBridgeList from "@/views/_BS/FieldFacilityBridgeList.vue";
import FieldFacilityRetainingWallList from "@/views/_BS/FieldFacilityRetainingWallList.vue";

export default {
  name: 'FieldListByCode',
  components: {
    FieldFacilityRetainingWallList,
    FieldFacilityBridgeList,
    ComplexDaycareList,
    ComplexBuildingList,
    ComplexOfficeList,
    ComplexIndoorAuditoriumList,
    ComplexMixedUseBuildingList,
    ComplexMedicalList,
    ComplexMuseumList,
    LibraryList,
    FieldFacilityComplexList,
  },
  computed: {
    fieldCode() {
      return this.$route.params.fieldCode;
    }
  }
};
</script>

<style scoped>

</style>
